import React, { useState, useEffect } from "react";
import axios from "axios";

const Autocomplete = () => {
  const [inputText, setInputText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [activeSuggestion, setActiveSuggestion] = useState(0);
  const [loading, setLoading] = useState(false);
  const [targetLang, setTargetLang] = useState("hin");

  const sourceLang = "eng";

  useEffect(() => {
    const fetchSuggestions = async () => {
      const lastWord = inputText.split(" ").pop();

      // Only allow English letters
      if (!lastWord || !/^[a-zA-Z]+$/.test(lastWord)) {
        setSuggestions([]);
        setShowSuggestions(false);
        return;
      }

      setLoading(true);

      try {
        const response = await axios.post(
          "https://transliteration.ebslab.in/api/getkbesttranstext",
          {
            text: lastWord,
            src: sourceLang,
            tgt: targetLang,
            kbest: 5,
          }
        );

        if (response.status === 200 && response.data?.data?.length > 0) {
          const uniqueSuggestions = [
            ...new Set(response.data.data.filter(Boolean)),
          ];

          setSuggestions(uniqueSuggestions);
          setShowSuggestions(true);
          setActiveSuggestion(0);
        } else {
          setSuggestions([]);
          setShowSuggestions(false);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestions([]);
        setShowSuggestions(false);
      }

      setLoading(false);
    };

    const debounce = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(debounce);
  }, [inputText, targetLang]);

  const handleChange = (e) => {
    setInputText(e.target.value);
  };

  const handleSelect = (selectedWord) => {
    const words = inputText.trim().split(" ");
    words[words.length - 1] = selectedWord;

    setInputText(words.join(" ") + " ");
    setSuggestions([]);
    setShowSuggestions(false);
  };

  const handleKeyDown = (e) => {
    if (!showSuggestions || suggestions.length === 0) return;

    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleSelect(suggestions[activeSuggestion]);
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveSuggestion((prev) => (prev + 1) % suggestions.length);
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveSuggestion((prev) => (prev - 1 + suggestions.length) % suggestions.length);
    }

    if (e.key === "Escape") {
      setShowSuggestions(false);
    }
  };

  return (
    <>
      <div className="flex items-center justify-center mb-3 w-full">
        <label className="mr-5 text-lg font-semibold">
          Choose language:
        </label>

        <select
          className="w-56 p-3 border border-gray-300 rounded-lg"
          value={targetLang}
          onChange={(e) => setTargetLang(e.target.value)}
        >
          <option value="hin">Hindi</option>
          <option value="guj">Gujarati</option>
          <option value="ben">Bengali</option>
          <option value="tel">Telugu</option>
          <option value="urd">Urdu</option>
        </select>
      </div>

      <div className="relative w-full max-w-md mx-auto rounded-lg">
  <input
    type="text"
    className={`w-full p-3 border border-gray-300 rounded-lg text-lg ${
      targetLang === "urd" ? "urdu-font text-right" : ""
    }`}
    value={inputText}
    onChange={handleChange}
    onKeyDown={handleKeyDown}
    placeholder={targetLang === "urd" ? "ٹائپ کرنا شروع کریں..." : "Start typing..."}
    dir={targetLang === "urd" ? "rtl" : "ltr"}
  />

  {loading && <p className="text-gray-500 mt-2">Loading...</p>}

  {showSuggestions && suggestions.length > 0 && (
    <ul
      className={`w-full bg-white border border-gray-300 rounded-lg mt-1 shadow-lg ${
        targetLang === "urd" ? "urdu-font text-right" : ""
      }`}
      dir={targetLang === "urd" ? "rtl" : "ltr"}
    >
      {suggestions.map((word, index) => (
        <li
          key={index}
          className={`p-3 cursor-pointer ${
            index === activeSuggestion
              ? "bg-blue-500 text-white"
              : "hover:bg-gray-100"
          }`}
          onMouseEnter={() => setActiveSuggestion(index)}
          onClick={() => handleSelect(word)}
        >
          {word}
        </li>
      ))}
    </ul>
  )}
</div>

    </>
  );
};

export default Autocomplete;
